import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  makeStyles,
  tokens,
} from '@fluentui/react-components';

import { spacing } from '@/theme/tokens';

interface CaveatsPanelProps {
  caveats: readonly string[];
}

const useStyles = makeStyles({
  list: {
    margin: 0,
    paddingLeft: spacing.l,
    color: tokens.colorNeutralForeground2,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
});

export function CaveatsPanel({ caveats }: CaveatsPanelProps) {
  const classes = useStyles();
  return (
    <Accordion collapsible>
      <AccordionItem value="caveats">
        <AccordionHeader>Methodology &amp; caveats ({caveats.length})</AccordionHeader>
        <AccordionPanel>
          <ul className={classes.list}>
            {caveats.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
